import http from './api'

export const httpGetPrivateInvestmentFunds = (params) => {
  console.log("httpGetPrivateInvestmentFunds");
  return http({
    url: `/private_investment_funds/private_investment_funds/` ,
    method: 'GET',
    params,
  })
}

export const httpGetAllSecurities = (params) => {
  console.log("httpGetAllSecurities");
  return http({
    url: `/private_investment_funds/private_investment_funds/all_securities/` ,
    method: 'GET',
    params,
  })
}

export const httpGetAllSecurities2 = (params) => {
  console.log("httpGetAllSecurities2");
  return http({
    url: `/private_investment_funds/private_investment_funds/all_securities_select/` ,
    method: 'GET',
    params,
  })
}

export const httpGetPrivateInvestmentFund = (id) => {
  console.log("httpGetPrivateInvestmentFund");
  return http({
    url: `/private_investment_funds/private_investment_funds/${id}/` ,
    method: 'GET',
  })
}

export const httpCreatePrivateInvestmentFund = (data) => {
  console.log("httpCreatePrivateInvestmentFund");
  return http({
    url: `/private_investment_funds/private_investment_funds/` ,
    method: 'POST',
    data
  })
}

export const httpUpdatePrivateInvestmentFund = (id, data) => {
  console.log("httpUpdatePrivateInvestmentFund");
  return http({
    url: `/private_investment_funds/private_investment_funds/${id}/` ,
    method: 'PATCH',
    data
  })
}

export const httpDeletePrivateInvestmentFund = (id) => {
  console.log("httpDeletePrivateInvestmentFund");
  return http({
    url: `/private_investment_funds/private_investment_funds/${id}/` ,
    method: 'DELETE',
  })
}

// Rates

/** The latest 40 price rows of many securities in one request, by kind and id. */
export const httpGetRateHistory = (params) => {
  return http({
    url: `/private_investment_funds/rate_history/` ,
    method: 'GET',
    params,
  })
}

export const httpGetPrivateInvestimentFundDatas = (params) => {
  console.log("httpGetPrivateInvestimentFundDatas");
  return http({
    url: `/private_investment_funds/private_investment_fund_datas/` ,
    method: 'GET',
    params,
  })
}

export const httpGetPrivateInvestimentFundData = (id) => {
  console.log("httpGetPrivateInvestimentFundData");
  return http({
    url: `/private_investment_funds/private_investment_fund_datas/${id}/` ,
    method: 'GET',
  })
}

export const httpCreatePrivateInvestimentFundData = (data) => {
  console.log("httpCreatePrivateInvestimentFundData");
  return http({
    url: `/private_investment_funds/private_investment_fund_datas/` ,
    method: 'POST',
    data,
  })
}

export const httpUpdatePrivateInvestimentFundData = (id, data) => {
  console.log("httpUpdatePrivateInvestimentFundData");
  return http({
    url: `/private_investment_funds/private_investment_fund_datas/${id}/` ,
    method: 'PATCH',
    data
  })
}

export const httpDeletePrivateInvestimentFundData = (id) => {
  console.log("httpDeletePrivateInvestimentFundData");
  return http({
    url: `/private_investment_funds/private_investment_fund_datas/${id}/` ,
    method: 'DELETE',
  })
}

export const httpGetAllSectors = (params) => {
  console.log("httpGetAllSectors");
  return http({
    url: `/private_investment_funds/get_all_sectors/` ,
    method: 'GET',
    params,
  })
}

export const httpUpdateAccountingPrice = (data,params) => {
  console.log("httpCreatePrivateInvestimentFundData");
  return http({
    url: `/private_investment_funds/private_investment_funds/update_accounting_price/` ,
    method: 'POST',
    data,
    params
  })
}

// Price source binding. resolve_isin only reads (it calls Infront and FMP), bind_price_source
// re-resolves server-side before writing, and set_manual_pricing marks a security as one the
// customer prices by hand so the nightly run leaves it alone.
export const httpResolveIsin = (data) => {
  return http({
    url: `/private_investment_funds/private_investment_funds/resolve_isin/`,
    method: 'POST',
    data,
  })
}

export const httpBindPriceSource = (id, data) => {
  return http({
    url: `/private_investment_funds/private_investment_funds/${id}/bind_price_source/`,
    method: 'POST',
    data,
  })
}

export const httpSetManualPricing = (id, data) => {
  return http({
    url: `/private_investment_funds/private_investment_funds/${id}/set_manual_pricing/`,
    method: 'POST',
    data,
  })
}
